import { IAccountInfo } from "../interfaces/iaccount-info";
import { ICustomerInfo } from "../interfaces/icustomer-info";

/** Returns an array of accounts that have passed roles grouped by customer */
export const groupAccountsByCustomerAndRoles = (accountInfos: IAccountInfo[], roles: string[]): ICustomerInfo[] => {
    return accountInfos.reduce((acc: ICustomerInfo[], account: IAccountInfo) => {
        // Check if account has any of the specified roles
        const hasRole = account.roles.some(role => roles.includes(role));
        if (!hasRole) return acc; // Skip if account doesn't have required roles

        // Find if Customer already exists in the accumulator
        const existingCustomer = acc.find(c => c.customerName === account.customerName);

        if (existingCustomer) {
            // If Customer exists, push the account to their accounts array
            existingCustomer.accountInfos.push({
                customerName: account.customerName || "Customer Name not Found",
                uuid: account.uuid,
                name: account.name,
                roles: account.roles
            });
        } else {
            // If Customer does't exist, create new entry
            acc.push({
                customerName: account.customerName || "Customer Name not Found",
                accountInfos: [{
                    customerName: account.customerName || "Customer Name not Found",
                    uuid: account.uuid,
                    name: account.name,
                    roles: account.roles
                }]
            });
        }

        return acc;
    }, []);
}
